module.exports = __webpack_public_path__ + "img/featuresBg.c1dd646d.png";